module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/colourfunLogoLayer-a17c10bda3f837c8797bc2d0bb1d957b.png";